module.exports = __webpack_public_path__ + "img/b_9.261012d5.jpg";